import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import {
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Loading } from "app/components";
import { Button } from "primereact/button";
import { formatDate } from "app/utils/utility.service";
import { getSessionUserInformation } from "app/utils/utility.service";
import { NumericFormat } from "react-number-format";
import { formatNumber } from "app/utils/utility.service";
import { confirmDialog } from "primereact/confirmdialog";
import moment from "moment";
import { addCoupon, editCoupons, fetchCoupons } from "../subscription.service";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";

const initialState = {
    code: "",
    discountType: "",
    discountValue : 0,
    maxRedemptions:0,
    applicableRoles: ['agent','broker','client'],
    redeemBy : "",
    planId: "",
    startDate : "",
    is_active: true,
};

const AddCoupons = ({
  couponModal,
  handleAddCouponModal,
  setCouponDetails,
  couponDetails,
  title,
  values,
  setValues,
  pdate
}) => {
  const toast = useRef();
  const [selectedId, setSelectedId] = useState(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [dateValidationError, setDateValidationError] = useState("");
  const [searchParams] = useSearchParams();
  const sessionValues = getSessionUserInformation();
  const clientId = searchParams.get("clientid");
  const [isLoading, setIsLoading] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState([]);
  const [valuesModified, setValuesModified] = useState(false);
  const [label, setLabel] = useState("");
  const onHide = (data) => {
    setFormSubmitted(false);
    setDateValidationError("");
    setValues(initialState);
    handleAddCouponModal(false);

  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  // Function to handle input changes and calculations
  const handleChange = (name, value) => {
   
     setValues({
      ...values,
      [name]: parseFloat(value),
    });
  };
  const validateInput = () => {
    // Clear previous date validation error
    setDateValidationError("");
    
    if (
      !values.code ||
      !values.startDate ||
      !values.redeemBy ||
      !values.discountValue
    ) {
      return false;
    }
    
    // Validate that redeemBy date is after startDate
    if (values.startDate && values.redeemBy) {
      const start = new Date(values.startDate);
      const redeem = new Date(values.redeemBy);
      
      if (redeem <= start) {
        setDateValidationError("Redeem date must be after start date");
        return false;
      }
    }
    
    return true;
  };

  useEffect(() => {
    console.log("values", JSON.stringify(values))
    let label = title.indexOf("Add") > -1 ? "Add" : "Save";
    setLabel(label);

    const fetchCryptoDetails = async () => {
      const userId =
        clientId && clientId !== "null" ? clientId : sessionValues.id;
      let list = await fetchCoupons();
      if (list) {
        setIsLoading(false);

         setCouponDetails(list.data.coupons);
        if (title.indexOf("Add") !== -1) {
          setSelectedId(list.data.coupons[0]?.id);
         
        } 
      }
    };

    fetchCryptoDetails();
  }, [couponModal]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const handleInputChangeNumber = (name, e) => {
    let value = e.target.value.replace(/[$,]/g, "");

    if(name === 'projected_growth' && value.replace('%', '').trim() !== values.projected_growth ) {
      setValuesModified(true);
    } else {
      setValuesModified(false);
    }

    setValues({
      ...values,
      [name]: parseFloat(value),
    });
  };

  const handleRoleChange = (role, isChecked) => {
    const currentRoles = values.applicableRoles || [];
    let updatedRoles;
    
    if (isChecked) {
      // Add role if not already present
      updatedRoles = [...new Set([...currentRoles, role])];
    } else {
      // Remove role if present
      updatedRoles = currentRoles.filter(r => r !== role);
    }
    
    setValues({
      ...values,
      applicableRoles: updatedRoles
    });
  };

    
  const handleSubmit = async (e) => {

    e.preventDefault();
    setFormSubmitted(true);

    if (!validateInput()) {
      return false;
    }

    let details;
    setIsLoading(true);
    values.discountType = "amount";
    let msg = "";
    if (title.indexOf("Add") !== -1) {
      details = await addCoupon(values);
      if(details?.data?.success)
        setCouponDetails([...couponDetails, details?.data.coupon]); // Add to list
      
        
      msg = "Coupon details added successfully";
    } else {
      details = await editCoupons(values?.id, values);
      if(!!details?.data) {
      setCouponDetails(
        couponDetails.map((item) => (item.id === details?.data?.coupon?.id ? details?.data?.coupon : item))
      ); //Update list
    
    }
      msg = "Coupon details updated successfully";
    }
    if(details?.data?.success) {
      showSuccess(msg);
      setTimeout(() => {
        onHide(details?.data);
      }, 1000);
    } else {
      showError(details?.message);
    }
    setIsLoading(false);
  };
  const renderFooter = () => {
    return (
      <div>
        <div className="grid">
          <div className="col-3"></div>
          <div
            className={`${
              isDesktopOrLaptop ? "col-7" : "col-12 text-align-center"
            }`}
          >
            <Button
              label="Cancel"
              className="p-button-raised p-button-lg"
              onClick={() => onHide()}
            />
            <Button
              type="submit"
              label={label}
              className={`p-button-raised p-button-warning p-button-lg  ${
                isDesktopOrLaptop ? "" : "ml-4"
              }`}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dialog
      header={title}
      visible={couponModal}
      onHide={() => onHide()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "35vw", maxHeight: "90vh" }}
      contentStyle={{ height: "70vh", overflowY: "auto" }}
      footer={renderFooter()}
      className="AnnualExpenseModal"
      position="top"
      closeOnEscape={false}
      draggable={false}
    >
      <div className="center-align">
        {isLoading && <Loading />}
        <Toast ref={toast} className="ToastMessage" />
        <div className="AddPropertyForm">
          <div className={`mt-4 ${isDesktopOrLaptop ? "text-right" : ""}`}>
            <div className="grid">
              
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Coupon Code</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <span className="p-float-label">
                      <InputText
                        className="vw-inputtext-with-border"
                        autoComplete="off"
                        required={true}
                        name="code"
                        value={values?.code}
                        onChange={handleInputChange}
                      />
                    </span>
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.code && (
                      <small className="p-error">
                        Please enter coupon code
                      </small>
                    )}
                  </div>
                </div>
              </div>

             
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">
                  Start Date 
                </label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <Calendar
                      id="buttondisplay"
                      minDate={new Date()}
                      disabled={title.indexOf("Edit") !== -1}
                      name="startDate"
                      onChange={handleInputChange}
                      value={values?.startDate ? new Date(formatDate(values?.startDate)) : null}
                      showIcon
                    
                      dateFormat="mm/dd/yy"
                    />
                  </div>
                   <div className="text-align-left">
                    {formSubmitted && !values?.startDate && (
                      <small className="p-error">Please enter date</small>
                    )}
                 
                  </div>
                </div>
              </div>

               <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">
                  End Date 
                </label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <Calendar
                      id="buttondisplay"
                      minDate={new Date()}
                      disabled={title.indexOf("Edit") !== -1}
                      name="redeemBy"
                      onChange={handleInputChange}
                      value={values?.redeemBy ? new Date(formatDate(values?.redeemBy)) : null}
                      showIcon
                    
                      dateFormat="mm/dd/yy"
                    />
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.redeemBy && (
                      <small className="p-error">Please enter date</small>
                    )}
                    {dateValidationError && (
                      <small className="p-error">{dateValidationError}</small>
                    )}
                  </div>
                </div>
              </div>

             
              <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
                <label className="mt-3">Discount Amount</label>
              </div>
              <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
                <div className="field">
                  <div className="p-inputgroup">
                    <NumericFormat
                      className="input-field"
                      style={{ 
                        width: "100%",
                        backgroundColor: title.indexOf("Edit") !== -1 ? "#d9d9d9" : "",
                        opacity: title.indexOf("Edit") !== -1 ? 0.6 : 1
                      }}
                      thousandSeparator=","
                      autoComplete="off"
                      prefix="$ "
                      required={true}
                      disabled={title.indexOf("Edit") !== -1}
                      name="discountValue"
                      decimalScale={0}
                      allowNegative={false}
                      onValueChange={(vals) =>  setValues({
                        ...values,
                        "discountValue": parseFloat(vals.value),
                        })}
                      value={values?.discountValue}
                    />
                  </div>
                  <div className="text-align-left">
                    {formSubmitted && !values?.discountValue && (
                      <small className="p-error">
                        Please enter discount
                      </small>
                    )}
                  </div>
                </div>
              </div>
           

            {/* Max Redemptions Field */}
            <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
              <label className="mt-3">Max Redemptions</label>
            </div>
            <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
              <div className="field">
                <div className="p-inputgroup">
                  <InputNumber
                    className="vw-inputnumber-with-border"
                    autoComplete="off"
                    required={true}
                    disabled={title.indexOf("Edit") !== -1}
                    name="maxRedemptions"
                    value={values?.maxRedemptions}
                    onValueChange={handleInputChange}
                    
                    min="1"
                  />
                </div>

              </div>
            </div>

            {/* Role Selection */}
            <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
              <label className="mt-3">Applicable Roles</label>
            </div>
            <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
              <div className="field">
                <div className="p-inputgroup">
                  <div className="grid">
                    <div className="col-12 mt-3">
                      <div className="flex gap-4 align-items-center">
                        <div className="flex">
                          <Checkbox
                            inputId="agent-role"
                            name="agent"
                            checked={values.applicableRoles?.includes('agent')}
                            onChange={(e) => handleRoleChange('agent', e.checked)}
                          />
                          <label htmlFor="agent-role" className="ml-1">Agent</label>
                        </div>
                        <div className="flex ml-3">
                          <Checkbox
                            inputId="broker-role"
                            name="broker"
                            checked={values.applicableRoles?.includes('broker')}
                            onChange={(e) => handleRoleChange('broker', e.checked)}
                          />
                          <label htmlFor="broker-role" className="ml-1">Broker</label>
                        </div>
                        <div className="flex ml-3">
                          <Checkbox
                            inputId="client-role"
                            name="client"
                            checked={values.applicableRoles?.includes('client')}
                            onChange={(e) => handleRoleChange('client', e.checked)}
                          />
                          <label htmlFor="client-role" className="ml-1">Client</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-align-left">
                  {formSubmitted && values.applicableRoles?.length === 0 && (
                    <small className="p-error">
                      Please select at least one role
                    </small>
                  )}
                </div>
              </div>
            </div>

            {/* Active Status Dropdown */}
            <div className={`${isDesktopOrLaptop ? "col-3" : "col-11"}`}>
              <label className="mt-3">Status</label>
            </div>
            <div className={`${isDesktopOrLaptop ? "col-7" : "col-11"}`}>
              <div className="field">
                <div className="p-inputgroup p-float-label">
                    <span className="p-float-label">
                       
                  <Dropdown
                   value={values.is_active}
                    options={[
                      { label: 'Active', name: true },
                      { label: 'Inactive', name: false }
                    ]}
                     optionLabel="label"
                       optionValue="name"
                      style={{
                          border: "1px solid #ced4da", // Customize the border color and width
                          borderRadius: "3px", // Optional: round the corners
                          padding: "5px", // Optional: add padding for spacing
                        }}
                    onChange={(e) => setValues({ ...values, is_active: e.value })}
                    className="vw-dropdown w-full zipcode-dropdown"
                  />
                  </span>
                </div>
                <div className="text-align-left">
                  {formSubmitted && values.is_active === undefined && (
                    <small className="p-error">
                      Please select status
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
 </div>
  </Dialog>
);
};
export default AddCoupons;
